import { render, staticRenderFns } from "./Digitization.vue?vue&type=template&id=79b118d0&scoped=true&"
import script from "./Digitization.vue?vue&type=script&lang=js&"
export * from "./Digitization.vue?vue&type=script&lang=js&"
import style0 from "./Digitization.vue?vue&type=style&index=0&id=79b118d0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b118d0",
  null
  
)

export default component.exports